import { getBool, toGermanDateString } from "../helper/formatting-helper";

export const prepareConfiguration = (params) => {
    return {
        showLogo: params.has("showLogo") ? getBool(params.get("showLogo")) : null,
        logoAlignment: params.has("logoAlignment") ? params.get("logoAlignment") : "LEFT",
        secondaryColor: params.has("secondaryColor") ? params.get("secondaryColor") : "000000",
        primaryColor: params.has("primaryColor") ? params.get("primaryColor") : "FFFFFF",
        footerText: params.has("footerText") ? params.get("footerText") : "Beispieltext in der Fußzeile.",
        uploadedLogoFile: params.has("logoUUID")
            ? params.get("logoUUID")
            : process.env.REACT_APP_S3_PUBLIC_BUCKET + "/logos/placeholder.png",
        language: params.has("language") ? params.get("language") : null,
    };
};

export const prepareTemplateInvoice = (config) => {
    // Initialize state with params
    // when anything required is missing show an alert
    let invoice;
    let dueDate = new Date();
    dueDate.setDate(new Date().getDate() + 5);
    if (config) {
        invoice = {
            seller: {
                companyName: config.senderName,
                email: config.senderSupportMail,
                line1: config.senderLine1,
                line2: config.senderLine2,
                zip: config.senderZip,
                city: config.senderCity,
                country: config.senderCountry,
                countryName: config.senderCountryName,
                vatId: config.senderVatId,
                taxId: config.senderTaxId,
            },
        };
    } else {
        invoice = {
            seller: {
                companyName: "pathway solutions gmbh",
                email: "support@pathway-solutions.de",
                line1: "Alstertwiete 3",
                zip: "20099",
                city: "Hamburg",
                country: "DE",
                countryName: "Deutschland",
                vatId: "DE123456789",
                taxId: "DE123456789",
            },
        };
    }

    invoice = {
        ...invoice,
        orderName: "#12345",
        paymentMethod: "PayPal",

        dueDate: toGermanDateString(dueDate),
        paidAmount: 233.00,
        pendingAmount: 0.0,
        totalAmount: 233.00,
        totalTax: 33.00,
        totalAmountWithoutTax: 200.0,
        includesTaxes: true,
        currencyCode: "€",
        taxLines: [
            {
                taxAmount: 19.00,
                taxRatePercentage: 19,
                taxRate: 0.19,
            },
            {
                taxAmount: 14.00,
                taxRatePercentage: 7,
                taxRate: 0.07,
            },
        ],
        paidLines: [
            {
                amount: 233,
                method: "PayPal",
            },
        ],
        customer: {
            companyName: "Firmenname",
            personName: "Kundenname",
            email: "sample@example.com",
            line1: "Weg am Standrand",
            line2: "1",
            zip: "12345",
            city: "Hamburg",
            country: "DE",
            countryName: "Deutschland",
            vatId: "De 99 88 3322",
        },
        lineItems: [
            {
                quantity: 2,
                price: 50.0,
                title: "Stifte",
                name: "Buntstifte Regenbogen",
                totalAmount: 114.00,
                taxLines: [
                    {
                        taxAmount: 14,
                        taxRatePercentage: 7,
                        taxRate: 0.07,
                    },
                ],
                includesTaxes: true,
            },
            {
                quantity: 1,
                price: 100.00,
                title: "Schuhe",
                name: "Adidas Stan Smith 44 2/3",
                totalAmount: 119.00,
                taxLines: [
                    {
                        taxAmount: 19.00,
                        taxRatePercentage: 19,
                        taxRate: 0.19,
                    },
                ],
                includesTaxes: true,
            },
        ],
    };

    return invoice;
};

export const prepareTemplateCreditNote = (config) => {
    // Initialize state with params
    // when anything required is missing show an alert
    let creditNote;
    if (config) {
        creditNote = {
            orderName: "#12345",
            dueDate: "01. 04. 2021",
            totalTax: 3.19,
            totalAmountWithoutTax: 16.81,
            currencyCode: "€",
            reason: "Grund des Refunds",
            seller: {
                companyName: config.senderName,
                line1: config.senderLine1,
                line2: config.senderLine2,
                zip: config.senderZip,
                city: config.senderCity,
                country: config.senderCountry,
                countryName: config.senderCountryName,
                vatId: config.senderVatId,
                taxId: config.senderTaxId,
            },
            customer: {
                companyName: "Firmenname",
                personName: "Kundenname",
                line1: "Weg am Standrand 1",
                zip: "12345",
                city: "Hamburg",
                country: "DE",
                countryName: "Deutschland",
                vatId: "De 99 88 3322",
            },
            lineItems: [
                {
                    quantity: 2,
                    price: 10.0,
                    title: "Stifte",
                    name: "Buntstifte Regenbogen",
                    refundedAmount: 10.0,
                    taxLines: [
                        {
                            taxAmount: 3.19,
                            taxRate: 19,
                        },
                    ],
                },
            ],
            taxLines: [
                {
                    taxRate: 19,
                    taxAmount: 3.19,
                },
            ],
        };
    } else {
        creditNote = {
            orderName: "#12345",
            dueDate: "01. 04. 2021",
            totalTax: 3.19,
            totalAmountWithoutTax: 16.81,
            currencyCode: "€",
            reason: "Grund des Refunds",
            seller: {
                companyName: "pathway solutions gmbh",
                line1: "Alstertwiete 3",
                zip: "20099",
                city: "Hamburg",
                country: "DE",
                countryName: "Deutschland",
                vatId: "DE123456789",
                taxId: "DE123456789",
            },
            customer: {
                companyName: "Firmenname",
                personName: "Kundenname",
                line1: "Weg am Standrand 1",
                zip: "12345",
                city: "Hamburg",
                country: "DE",
                countryName: "Deutschland",
                vatId: "De 99 88 3322",
            },

            lineItems: [
                {
                    quantity: 2,
                    price: 10.0,
                    title: "Stifte",
                    name: "Buntstifte Regenbogen",
                    refundedAmount: 10.0,
                    taxLines: [
                        {
                            taxAmount: 3.19,
                            taxRate: 19,
                        },
                    ],
                },
            ],
            taxLines: [
                {
                    taxRate: 19,
                    taxAmount: 3.19,
                },
            ],
        };
    }

    return creditNote;
};